import { connect } from 'react-redux'
import AggregateDetails from '../../components/details/aggregate_details'
import { selectRoundOrderMap, selectIsManagerSite } from '../../selectors'

const mapStateToProps = (state, ownProps) => {
  const eventId = String(ownProps.eventId);
  const { detailsKey } = ownProps;

  const entry = state.details[eventId]?.[detailsKey];
  const rawData = entry?.data || {};
  const roundOrder = selectRoundOrderMap(state);

  // Reorder rounds in descending index order (highest first) for display in RoundSelector.
  // Reorder childAggregates to match descending round order, so if roundId has no match in childAggregates,
  // fallback to [0] will always return the last played round found.
  const data = rawData.childAggregates
    ? {
        ...rawData,
        childAggregates: [...rawData.childAggregates].sort(
          (a, b) => (roundOrder[String(a.roundId)] ?? 0) - (roundOrder[String(b.roundId)] ?? 0)
        ),
        rounds: [...(rawData.rounds ?? [])].sort(
          (a, b) => (roundOrder[String(b.id)] ?? 0) - (roundOrder[String(a.id)] ?? 0)
        ),
      }
    : rawData;

  return {
    data,
    loading: entry?.loading || false,
    error: entry?.error || null,
    holeByHoleView: state.leaderboardV2.holeByHoleView,
    roundId: state.leaderboardV2.roundId,
    leagueId: state.leaderboardV2.leagueId,
    isManagerSite: selectIsManagerSite(state),
    playerProfilesEnabled: Boolean(state.leaderboardV2.playerProfilesEnabled),
  }
};

export default connect(mapStateToProps)(AggregateDetails)
